import { axios } from "../cores/axiosWrapper";

import Polling from "./polling_v2";

import * as jobStatus from "../cores/jobStatus";
import { withRetryNetworkRequest } from "@utils/withRetryNetworkRequest";
import retryAsync from "@cores/retryInvoker";

const addJobStatusPolling = ({
    params,
    successCallback,
    errorCallback = undefined,
    targetStatus = jobStatus.values,
}) => {
    const targets = params.jobs ? params.jobs.filter((v) => targetStatus[v.status]) : [];
    if (targets.length <= 0) {
        return;
    }
    if (params.hasAssociations) {
        targets.forEach((t) => {
            new Polling(
                async () => {
                    return await retryAsync(
                        async () => {
                            const response = await withRetryNetworkRequest(() =>
                                axios.get(`${params.apiEndpoint}/jobs/${t.id}`, {
                                    cancelToken: params.cancelToken,
                                    headers: {
                                        stageId: params.stageId,
                                        projectId: params.projectId,
                                    },
                                }),
                            );
                            return response && response.data;
                        },
                        (e) => {
                            if (e?.response?.status === 403) {
                                throw e;
                            }
                            return false;
                        },
                    );
                },
                (response) => {
                    return !response || !jobStatus.isComplete(response.status);
                },
                successCallback,
                errorCallback ?? null,
            ).run();
        });
    } else {
        const ids = targets.map((t) => t.id).join(",");
        new Polling(
            async () => {
                return await retryAsync(
                    async () => {
                        const response = await withRetryNetworkRequest(() =>
                            axios.get(`${params.apiEndpoint}/jobs`, {
                                cancelToken: params.cancelToken,
                                headers: {
                                    stageId: params.stageId,
                                    projectId: params.projectId,
                                },
                                params: {
                                    ids,
                                },
                            }),
                        );

                        if (response?.data?.jobs && params.fetchJobDetailStatus) {
                            // fetchJobDetailStatus에 해당하는 job들 필터링
                            const jobsToFetchDetail = response.data.jobs.filter((job) =>
                                params.fetchJobDetailStatus.includes(job.status),
                            );

                            // 각 job에 대해 상세 조회
                            const detailPromises = jobsToFetchDetail.map((job) =>
                                withRetryNetworkRequest(() =>
                                    axios.get(`${params.apiEndpoint}/jobs/${job.id}`, {
                                        cancelToken: params.cancelToken,
                                        headers: {
                                            stageId: params.stageId,
                                            projectId: params.projectId,
                                        },
                                    }),
                                )
                                    .then((detailResponse) => detailResponse?.data)
                                    .catch(() => null),
                            );

                            const detailResults = await Promise.all(detailPromises);

                            // 상세 조회 결과로 배열의 객체 교체
                            response.data.jobs = response.data.jobs.map((job) => {
                                const detailIndex = jobsToFetchDetail.findIndex((j) => j.id === job.id);
                                if (detailIndex !== -1 && detailResults[detailIndex]) {
                                    return detailResults[detailIndex];
                                }
                                return job;
                            });
                        }

                        return response && response.data;
                    },
                    (e) => {
                        if (e?.response?.status === 403) {
                            throw e;
                        }
                        return false;
                    },
                );
            },
            (response) => {
                if (!response || !response.jobs) return true;
                const completeCount = response.jobs.filter((v) => jobStatus.isComplete(v.status)).length;
                if (completeCount === response.totalCount) return true;

                return false;
            },
            successCallback,
            errorCallback ?? null,
            5000,
        ).run();
    }
};

export default addJobStatusPolling;
